module.exports = __webpack_public_path__ + "img/podplayer-icon-white.66441419.png";